/**
 * What one saved-sentence control says, in all three of its states.
 *
 * **One answer, read by the markup and by the script.** The control is drawn
 * by the handler on `/user/liju/` and by Hugo on every 例句, and the script in
 * `src/site/save-liju.ts` relabels it in place when a reader presses it. Three
 * writers of the same three labels are three chances for a press to leave a
 * button reading something the server would never have drawn.
 *
 * `src/site/save-liju-draw.ts` is the browser half and imports this. Nothing
 * else under `src/user/` may follow it there. See `save-liju-routes.ts`.
 */

/** Text and compact-icon state for one saved-sentence control. */
export function savedLijuPresentation(properties: {
  readonly label: string;
  readonly held: boolean;
  readonly compactHeld: boolean;
}): {
  readonly accessibleLabel: string;
  readonly iconOnly: boolean;
  readonly visibleLabel: string;
} {
  if (!properties.held) {
    return {
      accessibleLabel: `Save ${properties.label}`,
      iconOnly: false,
      visibleLabel: "Save",
    };
  }

  if (properties.compactHeld) {
    return {
      accessibleLabel: `Remove ${properties.label} from saved sentences`,
      iconOnly: true,
      visibleLabel: "Remove",
    };
  }

  return {
    accessibleLabel: `Saved ${properties.label}, press to remove`,
    iconOnly: false,
    visibleLabel: "Saved",
  };
}
